import { NodeTagsFormValues } from "@features/administration/products/EditProduct/NodeTagsForm/NodeTagsForm"
import TagRow from "@features/administration/products/EditProduct/NodeTagsForm/TagRow"
import { TableBody, TableCell, TableRow } from "@mui/material"
import { useVirtualizer } from "@tanstack/react-virtual"
import type { RefObject } from "react"
import { FieldArrayWithId } from "react-hook-form"

const TABLE_ROW_ESTIMATED_HEIGHT_PX = 58

type VirtualizedTagRowsProps = {
  fields: FieldArrayWithId<NodeTagsFormValues, "rows", "id">[]
  tableContainerRef: RefObject<HTMLDivElement>
  onDelete: (index: number) => void
}

const VirtualizedTagRows = (props: VirtualizedTagRowsProps) => {
  const rowVirtualizer = useVirtualizer({
    count: props.fields.length,
    getScrollElement: () => props.tableContainerRef.current,
    estimateSize: () => TABLE_ROW_ESTIMATED_HEIGHT_PX,
    overscan: 10,
  })

  const virtualItems = rowVirtualizer.getVirtualItems()
  const paddingTop = virtualItems[0]?.start ?? 0
  const paddingBottom =
    virtualItems.length > 0
      ? rowVirtualizer.getTotalSize() - (virtualItems[virtualItems.length - 1]?.end ?? 0)
      : 0

  return (
    <TableBody>
      {paddingTop > 0 && (
        <TableRow>
          <TableCell sx={{ border: 0, p: 0, height: paddingTop }} />
        </TableRow>
      )}

      {virtualItems.map((virtualRow) => {
        const field = props.fields[virtualRow.index]

        return (
          <TagRow
            key={field?.id ?? virtualRow.key}
            index={virtualRow.index}
            onDelete={props.onDelete}
          />
        )
      })}

      {paddingBottom > 0 && (
        <TableRow>
          <TableCell sx={{ border: 0, p: 0, height: paddingBottom }} />
        </TableRow>
      )}
    </TableBody>
  )
}

export default VirtualizedTagRows
